(function(){'use strict';const trail={trailKey:'',raf:0,queueTrail(){if(this.raf)return;this.raf=requestAnimationFrame(()=>{this.raf=0;this.drawTrail()})},  footSvg(ink) {
    return '<path d="M12 16V4.8M12 16L18 9.4M12 16L6 9.4M12 16L11.4 20.4" fill="none" stroke="' + ink + '" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>';
  },

  // a single walk down the whole page: along one edge, across each section's bottom padding,
  // straight through short bands, ending beside the last BUY NOW
  drawTrail() {
    const layers = Array.from(document.querySelectorAll('[data-trail]'));
    if (!layers.length) return;
    const sy = window.pageYOffset;
    const secs = layers.map((layer) => {
      const r = layer.getBoundingClientRect();
      return { layer, top: r.top + sy, left: r.left, h: r.height, w: r.width, cream: layer.getAttribute('data-trail') === 'cream' };
    }).filter((s) => s.h > 0 && s.w > 0);
    if (!secs.length) return;
    const W = secs[0].w;
    const ck = document.querySelector('[data-anchor="chick"]');
    const ckr = ck && ck.getBoundingClientRect();
    const key = Math.round(W) + '|' + secs.map((s) => Math.round(s.top) + ':' + Math.round(s.h)).join(',') + (ckr ? '|' + Math.round(ckr.left) + ':' + Math.round(ckr.top + window.pageYOffset) + ':' + Math.round(ckr.height) : '');
    if (key === this.trailKey && secs.every((s) => s.layer.firstChild)) return;
    this.trailKey = key;

    const mobile = W < 700;
    const size = mobile ? 22 : 30, stride = mobile ? 46 : 62, spread = mobile ? 7 : 10;
    const gut = mobile ? 20 : Math.max(34, Math.min(92, (W - 1184) / 4));
    const L = gut, R = W - gut, x0 = secs[0].left, last = secs[secs.length - 1];
    const ce = document.querySelector('[data-anchor="chick"]'), cr = ce && ce.getBoundingClientRect();
    const hasChick = !!(cr && cr.width);
    // come down to the right of the chick, flatten onto its ground line, walk in and vanish underneath it
    const gy = hasChick ? cr.bottom + sy - 12 : 0;
    const end = hasChick ? [Math.min(W - 14, cr.right - x0 + (mobile ? 34 : 80)), gy - (mobile ? 46 : 80)] : [R, last.top + last.h - 40];
    const tuck = hasChick ? [cr.left - x0 + cr.width * 0.5, gy] : null;

    // weave: long, even S-curves from gutter to gutter, turning near section edges, ending at the chick
    const minH = mobile ? 420 : 700, maxH = mobile ? 900 : 1300;
    const cuts = [secs[0].top - 30];
    secs.slice(1).forEach((s) => { if (s.top - cuts[cuts.length - 1] >= minH && end[1] - s.top >= minH) cuts.push(s.top); });
    cuts.push(end[1]);
    const spans = [];
    for (let i = 0; i < cuts.length - 1; i++) {
      const y1 = cuts[i], y2 = cuts[i + 1], n = Math.max(1, Math.ceil((y2 - y1) / maxH));
      for (let j = 0; j < n; j++) spans.push([y1 + (y2 - y1) * j / n, y1 + (y2 - y1) * (j + 1) / n]);
    }
    if (spans.length % 2 === 0) { // odd count so the walk finishes on the right
      let m = 0; spans.forEach((sp, i) => { if (sp[1] - sp[0] > spans[m][1] - spans[m][0]) m = i; });
      const y1 = spans[m][0], y2 = spans[m][1]; spans.splice(m, 1, [y1, (y1 + y2) / 2], [(y1 + y2) / 2, y2]);
    }
    const poly = [], meta = [];
    spans.forEach((sp, i) => {
      const xa = i % 2 ? R : L, xb = i === spans.length - 1 ? end[0] : (i % 2 ? L : R);
      const n = Math.ceil(Math.hypot(xb - xa, sp[1] - sp[0]) / 5);
      for (let j = i ? 1 : 0; j <= n; j++) {
        const s = j / n;
        poly.push([xa + (xb - xa) * (1 - Math.cos(Math.PI * s)) / 2, sp[0] + (sp[1] - sp[0]) * s]);
        meta.push([s, i % 2 ? -1 : 1]);
      }
    });
    // subtle weave along each sweep, fading out at the turns
    const amp = mobile ? 10 : 26, base = poly.map((p) => p.slice());
    for (let i = 0; i < poly.length; i++) {
      const p0 = base[Math.max(0, i - 1)], p1 = base[Math.min(poly.length - 1, i + 1)];
      const tx = p1[0] - p0[0], ty = p1[1] - p0[1], tl = Math.hypot(tx, ty) || 1, s = meta[i][0];
      const o = amp * meta[i][1] * Math.sin(Math.PI * s) * Math.sin(2 * Math.PI * s);
      poly[i] = [Math.max(10, Math.min(W - 10, base[i][0] - ty / tl * o)), base[i][1] + tx / tl * o];
    }
    if (tuck) {
      const FL = 0.42, a = poly[poly.length - 1], b = [a[0] - (mobile ? 30 : 56), gy], c = [a[0], gy];
      const n1 = Math.ceil((Math.abs(gy - a[1]) + Math.abs(b[0] - a[0])) / 5);
      for (let j = 1; j <= n1; j++) {
        const t = j / n1, u = 1 - t;
        poly.push([u * u * a[0] + 2 * u * t * c[0] + t * t * b[0], u * u * a[1] + 2 * u * t * c[1] + t * t * b[1], 1 - (1 - FL) * t]);
      }
      const n2 = Math.max(1, Math.ceil(Math.abs(b[0] - tuck[0]) / 5));
      for (let j = 1; j <= n2; j++) poly.push([b[0] + (tuck[0] - b[0]) * j / n2, gy, FL]);
    }
    const cum = [0];
    for (let i = 1; i < poly.length; i++) cum.push(cum[i - 1] + Math.hypot(poly[i][0] - poly[i - 1][0], poly[i][1] - poly[i - 1][1]));
    const total = cum[cum.length - 1];
    const at = (d) => {
      let lo = 0, hi = cum.length - 1;
      while (lo < hi - 1) { const mid = (lo + hi) >> 1; if (cum[mid] < d) lo = mid; else hi = mid; }
      const q = (d - cum[lo]) / ((cum[hi] - cum[lo]) || 1);
      const f0 = poly[lo][2] == null ? 1 : poly[lo][2], f1 = poly[hi][2] == null ? 1 : poly[hi][2];
      return [poly[lo][0] + (poly[hi][0] - poly[lo][0]) * q, poly[lo][1] + (poly[hi][1] - poly[lo][1]) * q, f0 + (f1 - f0) * q];
    };
    const feet = [];
    const place = (d, left) => {
      const p = at(d), p1 = at(Math.max(0, d - 4)), p2 = at(Math.min(total, d + 4));
      const hd = Math.atan2(p2[1] - p1[1], p2[0] - p1[0]), sg = left ? 1 : -1;
      feet.push({ x: p[0] + Math.sin(hd) * spread * sg, y: p[1] - Math.cos(hd) * spread * sg * p[2], rot: hd * 180 / Math.PI + 90 + (left ? -8 : 8), left, fl: p[2] });
    };
    let d = 0, n2 = 0;
    while (d < total - stride * 0.45) { place(d, n2 % 2 === 0); n2++; d += stride; }
    place(total, n2 % 2 === 0);
    place(total, n2 % 2 !== 0); // both feet together at the end

    const k = size / 24;
    secs.forEach((s, i) => {
      const ink = s.cream ? '#FBF6EC' : '#0A3161';
      let body = '';
      feet.forEach((ft) => {
        const ly = ft.y - s.top;
        if (ly < -size || ly > s.h + size) return;
        body += '<use href="#lfpf' + i + '" transform="translate(' + ft.x.toFixed(1) + ' ' + ly.toFixed(1) + ')' + (ft.fl < 0.995 ? ' scale(1 ' + ft.fl.toFixed(3) + ')' : '') + ' rotate(' + ft.rot.toFixed(1) + ') scale(' + (ft.left ? -k : k).toFixed(3) + ' ' + k.toFixed(3) + ') translate(-12 -12)"/>';
      });
      s.layer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="' + Math.round(s.w) + '" height="' + Math.round(s.h) + '" style="position:absolute;left:0;top:0;display:block;overflow:hidden">' +
        '<defs><g id="lfpf' + i + '" fill="' + ink + '">' + this.footSvg(ink) + '</g></defs>' +
        '<g opacity="' + (s.cream ? 0.18 : 0.12) + '">' + body + '</g></svg>';
    });
  },};let width=window.innerWidth;const run=()=>trail.queueTrail();const resize=()=>{if(window.innerWidth===width)return;width=window.innerWidth;run()};const reset=()=>{trail.trailKey='';run()};window.addEventListener('resize',resize,{passive:true});window.addEventListener('load',run);document.addEventListener('shopify:section:load',reset);document.addEventListener('shopify:section:unload',reset);document.addEventListener('shopify:section:reorder',reset);if(document.fonts)document.fonts.ready.then(run);run();window.LFPTrail=trail;}());